import { EventState } from '@/enums/EventState';
import { AnyThinEvent } from '@/utils/eventHelpers';

export const getEventHref = (event: AnyThinEvent): string => {
  if (event.state === EventState.PostEvent) {
    return `/events/${event.id}/library`;
  }

  return `/events/${event.id}/reception`;
};

export const getEventHrefFull = (event: AnyThinEvent): string => {
  if (event.state === EventState.PostEvent) {
    return `${process.env.NEXT_PUBLIC_BASE_URL}/events/${event.id}/library`;
  }

  return `${process.env.NEXT_PUBLIC_BASE_URL}/events/${event.id}/reception`;
};
